<script setup>
import { computed } from 'vue';

const props = defineProps({
  level: {
    type: Number,
    default: null,
  },
  squashLevelId: {
    type: Number,
    default: null,
  },
  size: {
    type: String,
    default: 'small',
  },
});

const imgWidth = computed(() => (props.size === 'x-small' ? '12px' : '18px'));

const onClick = () => {
  if (props.squashLevelId) {
    window.open(`https://app.squashlevels.com/player_detail?&player=${props.squashLevelId}`, '_blank');
  }
};

</script>

<template>
  <v-chip @click="onClick" :size="props.size" variant="flat" class="sl-chip" v-if="props.level !== null">
    <v-img
        class="mr-1"
        src="/images/sl_icon.png"
        alt="Squash level"
        :width="imgWidth"
    ></v-img>
    {{ props.level }}
  </v-chip>
</template>

<style scoped>
/* neutral chip per mockups/redesign .chip (bg tint + hairline, ink-2 text) */
.sl-chip {
  font-weight: 600;
  background: rgb(var(--v-theme-light)) !important;
  color: rgb(var(--v-theme-charcoal)) !important;
  border: 1px solid rgb(var(--v-theme-borderLight));
}
</style>
